<template>
  <VoteBase>
    <template v-slot:voteMain>
      <voteItemForm :func="funcType" :isUpdate="isUpdate" :defaultLimitConfig="defaultLimitConfig" @submitData="submitData($event)" />
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import voteItemForm from '@/components/Vote/VoteItemForm'
import VoteBase from './Base'

export default {
  name: 'item-create',
  components: {voteItemForm, VoteBase},
  mixins: [Error],
  data () {
    return {
      funcType: '创建',
      isUpdate: false,
      data: null,
      defaultLimitConfig: {}
    }
  },
  created () {
    api.detailVoteData(this, api.getVoteDetail(), 'GET', 'data', {app_id: this.$route.params.appId}, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.detailDataCallback)
  },
  methods: {
    submitData (data) {
      api.createVoteData(this, api.getVoteItemCreate(), 'POST', data, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.backToList)
    },
    backToList () {
      this.$router.push({name: 'vote-item', params: {appId: this.$route.params.appId}, query: {oversea: !!JSON.parse(this.$route.query.oversea)}})
    },
    detailDataCallback () {
      let tmpData = this.data.limit_config
      this.defaultLimitConfig = {
        is_limit: tmpData.is_limit >= 1,
        every: tmpData.every,
        user_limit_num: tmpData.user_limit_num,
        limit_start_time: tmpData.limit_start_time,
        limit_end_time: tmpData.limit_end_time,
        limit_vote_num: tmpData.limit_vote_num,
        user_item_limit_num: tmpData.user_item_limit_num
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ItemCreate.vue?3160a476